module.exports = __webpack_public_path__ + "img/downloadImg_1.baf5d4c4.jpg";